import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service for managing AI chat route context
 * Routes provide additional context to AI requests (e.g., 'TEST_MIGRATION', 'TEXT_TO_TEST')
 */
@Injectable({
    providedIn: 'root'
})
export class AiChatRouteService {
    private readonly currentRoute$ = new BehaviorSubject<string | undefined>(undefined);

    /**
     * Observable of the current route context
     */
    public get route$(): Observable<string | undefined> {
        return this.currentRoute$.asObservable();
    }

    /**
     * Gets the current route value synchronously
     */
    public get currentRoute(): string | undefined {
        return this.currentRoute$.value;
    }

    /**
     * Sets the route context for AI requests
     * @param route The route identifier (e.g., 'TEST_MIGRATION', 'TEXT_TO_TEST')
     */
    public setRoute(route?: string): void {
        this.currentRoute$.next(route);
    }

    /**
     * Clears the current route context
     */
    public clearRoute(): void {
        this.setRoute(undefined);
    }

    /**
     * Checks if a specific route is currently active
     * @param route The route to check
     */
    public isRouteActive(route: string): boolean {
        return this.currentRoute$.value === route;
    }
}
